const TESTIMONIALS = [
  {
    text: 'Kamil nám spravil web za týždeň. Profesionálny prístup, výsledok prekonal očakávania.',
    author: 'Martin S.',
    company: 'ICF House',
  },
  {
    text: 'Rezervačný systém funguje perfektne. Zákazníci ho chvália každý deň.',
    author: '',
    company: 'Boxy Nosiče',
  },
  {
    text: 'Konečne web ktorý nás reprezentuje. Odporúčam každému.',
    author: '',
    company: 'Salón Sirka',
  },
];

const Stars = () => (
  <div className="testimonial-stars" aria-label="Hodnotenie 5 z 5 hviezdičiek">
    {[...Array(5)].map((_, i) => (
      <svg key={i} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
      </svg>
    ))}
  </div>
);

const QuoteIcon = () => (
  <svg className="testimonial-quote-icon" viewBox="0 0 32 32" aria-hidden="true">
    <path d="M10 8C6.13 8 3 11.13 3 15v9h9v-9H6c0-2.21 1.79-4 4-4V8zm16 0c-3.87 0-7 3.13-7 7v9h9v-9h-6c0-2.21 1.79-4 4-4V8z"/>
  </svg>
);

export default function Testimonials() {
  return (
    <section id="referencie" aria-labelledby="referencie-heading">
      <div className="container">
        <div className="section-header">
          <span className="section-tag fade-up">Referencie</span>
          <h2 id="referencie-heading" className="section-h2 fade-up delay-1">
            Čo hovoria <span className="grad">klienti</span>
          </h2>
        </div>
        <div className="testimonials-grid">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.company}
              className={`testimonial-card fade-up${i > 0 ? ` delay-${i}` : ''}`}
            >
              <QuoteIcon />
              <Stars />
              <p className="testimonial-text">"{t.text}"</p>
              <div className="testimonial-author">
                <div className="author-avatar" aria-hidden="true">
                  {(t.author || t.company).charAt(0)}
                </div>
                <div className="author-info">
                  {t.author && <div className="author-name">{t.author}</div>}
                  <div className="author-company">{t.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
